<template>
  <div>
    <!-- 顶部导航 -->
    <TopNav></TopNav>
    <!-- 智能安防轮播图 -->
    <SecurityBanner></SecurityBanner>
    <!-- 安防系统详情 -->
    <SecurityDetails></SecurityDetails>
    <!-- 底部导航 -->
    <ButtonNav></ButtonNav>
  </div>
</template>

<script>
import { reactive } from "vue";

import TopNav from "../../../../components/mobile/components/TopNav.vue";
import ButtonNav from "../../../../components/mobile/components/BottomNav.vue";
import SecurityBanner from '../../../../components/mobile/Programme/SecurityComponents/SecurityBanner.vue'
import SecurityDetails from '../../../../components/mobile/Programme/SecurityComponents/SecurityDetails.vue'

export default {
  setup() {
    return reactive({});
  },
  components: {
    TopNav,
    ButtonNav,
    SecurityBanner,
    SecurityDetails
  },
};
</script>

<style scoped>
</style>
